export default __webpack_public_path__ + "static/media/notes.fe4c32a1.svg";